import { FC, ReactNode } from 'react';
import { GroupSection } from '../GroupSection';
import { groupKey, useAllocationGroups } from '../useAllocationGroups';
import { AllocationGroup } from '../types';

type Props = {
  className: string;
  renderInputControl: (
    group: AllocationGroup,
    onGroupChange: (patch: Partial<AllocationGroup>) => void,
    isLastGroup: boolean
  ) => ReactNode;
};

export const AllocationTable: FC<Props> = ({ className, renderInputControl }) => {
  const {
    recipients,
    recipientsSelected,
    recipientGroups,
    canAddGroup,
    handleAddGroup,
    handleRemoveGroup,
    handleMoveRecipient,
    handleReorderGroup,
    handleGroupPatch,
  } = useAllocationGroups();

  if (recipientsSelected.length === 0) return null;

  return (
    <div className={className}>
      {recipientGroups.map((group, groupIndex) => (
        <GroupSection
          key={groupKey(group)}
          group={group}
          groupIndex={groupIndex}
          groupCount={recipientGroups.length}
          recipients={recipients}
          inputControl={renderInputControl(
            group,
            patch => handleGroupPatch(groupIndex, patch),
            groupIndex === recipientGroups.length - 1
          )}
          onMoveRecipient={(recipientId, toGroupIndex) =>
            handleMoveRecipient(recipientId, groupIndex, toGroupIndex)
          }
          onReorder={newOrder => handleReorderGroup(groupIndex, newOrder)}
          onRemove={() => handleRemoveGroup(groupIndex)}
          onGroupChange={patch => handleGroupPatch(groupIndex, patch)}
        />
      ))}
      {canAddGroup && (
        <button
          type="button"
          className="link-text oath-bodysmall gray padding0"
          onClick={handleAddGroup}
        >
          Add Group {recipientGroups.length + 1}
        </button>
      )}
    </div>
  );
};
